<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'detailsInfo'
}
</script>

<style>

</style>
